module.exports = __webpack_public_path__ + "static/media/folderIcon.81dfc6d7.svg";